import React, { useEffect } from "react";
import useProductStore from "../../Stores/useProductStore";
import InfiniteScrollList from "../../Components/Shared/InfiniteScroll/InfiniteScrollList";
import NewPolaroid from "../../Components/Products/NewPolaroid";
import styles from "./WholesaleProducts.module.css";
import BreadCrumb from "../../Components/Products/BreadCrumb/BreadCrumb";
function WholesaleProducts() {
  const { wholeSaleItems, loadingWholeSale, getWholeSaleItems } =
    useProductStore();

  useEffect(() => {
    const fetchWholeSaleItems = async () => {
      await getWholeSaleItems();
    };
    if (wholeSaleItems.length === 0) {
      fetchWholeSaleItems();
    }
  }, []);

  return (
    <div className={styles.WholesaleProducts}>
      <div className={styles.Header}>
        <BreadCrumb Route="Wholesale" ProductName="Products" />
        <h1 className={styles.WholesaleTitle}>Wholesale Products</h1>        
      </div>
      <div className={styles.Wrapper}>
        <InfiniteScrollList
          fetchItems={getWholeSaleItems}
          pageSize={20}
          RenderItem={NewPolaroid}
          itemProps={{ Route: "Wholesale/Products" }}
        />
      </div>
    </div>
  );
}

export default WholesaleProducts;
